// extracted by mini-css-extract-plugin
module.exports = {"label":"CourseAttribute_label__DuKtC","text":"CourseAttribute_text__Y07Zg","link":"CourseAttribute_link__JlJm7"};